import { ImportProgress as Progress } from 'helpers/import-types';
import styles from '../vault-import.module.scss';

const RING_SIZE = 180;
const RING_STROKE = 12;

/** Full-screen progress while files upload. */
export const ImportProgress = ({
  progress,
  completed,
  total,
}: {
  progress: Progress | null;
  completed: number;
  total: number;
}) => {
  const pct = total > 0 ? Math.round((completed / total) * 100) : 0;
  const radius = (RING_SIZE - RING_STROKE) / 2;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (pct / 100) * circumference;

  return (
    <div className={styles.importingScreen}>
      <div
        className={styles.ringWrap}
        style={{ width: RING_SIZE, height: RING_SIZE }}
      >
        <div className={styles.ringGlow} />
        <div className={styles.ringOrbit}>
          <span className={styles.orbitDot} />
          <span className={styles.orbitDot} />
          <span className={styles.orbitDot} />
        </div>
        <svg
          className={styles.ringSvg}
          width={RING_SIZE}
          height={RING_SIZE}
          viewBox={`0 0 ${RING_SIZE} ${RING_SIZE}`}
        >
          <defs>
            <linearGradient id="ringGrad" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#a3b9ba" />
              <stop offset="50%" stopColor="#2d6165" />
              <stop offset="100%" stopColor="#023f42" />
            </linearGradient>
          </defs>
          <circle
            className={styles.ringTrack}
            cx={RING_SIZE / 2}
            cy={RING_SIZE / 2}
            r={radius}
            strokeWidth={RING_STROKE}
            fill="none"
          />
          <circle
            className={styles.ringProgress}
            cx={RING_SIZE / 2}
            cy={RING_SIZE / 2}
            r={radius}
            strokeWidth={RING_STROKE}
            fill="none"
            stroke="url(#ringGrad)"
            strokeLinecap="round"
            strokeDasharray={circumference}
            strokeDashoffset={offset}
            transform={`rotate(-90 ${RING_SIZE / 2} ${RING_SIZE / 2})`}
          />
        </svg>
        <div className={styles.ringCore}>
          <div className={styles.ringPercent}>{pct}%</div>
          <div className={styles.ringLabel}>Importing</div>
        </div>
      </div>

      <div className={styles.shimmerTrack}>
        <div className={styles.shimmerFill} style={{ width: `${pct}%` }} />
      </div>

      {progress && (
        <div className={styles.statusBlock}>
          <div className={styles.statusLine}>
            <span className={styles.statusLabel}>Album</span>
            <span className={styles.statusCount}>
              {progress.albumIndex + 1} / {progress.albumTotal}
            </span>
            <span className={styles.statusName}>{progress.albumName}</span>
          </div>
          <div className={styles.statusLine}>
            <span className={styles.statusLabel}>File</span>
            <span className={styles.statusCount}>
              {progress.fileIndex + 1} / {progress.fileTotal}
            </span>
            <span className={styles.statusName}>{progress.fileName}</span>
          </div>
        </div>
      )}
    </div>
  );
};
